import { c as _c } from "react/compiler-runtime";
import { useAppStore } from '@repo/store/maps/hooks';
import { selectFogOfWarActive, selectLayerVisibility, selectMapData } from '@repo/store/maps/slices/mapData';
import { isPointInRegion } from '@repo/types/maps/map-utils';
import type * as MapLibre from 'maplibre-gl';
import { useCallback, useEffect, useState } from 'react';
import { PIN_INTERACTION_LAYER_IDS } from '../game-map/hooks/constants';
import { useMapContext } from '../game-map/map-context';
export interface FogContextMenuState {
  isOpen: boolean;
  x: number;
  y: number;
}
const INITIAL_STATE: FogContextMenuState = {
  isOpen: false,
  x: 0,
  y: 0
};
export function useFogContextMenu() {
  const $ = _c(10);
  const {
    map
  } = useMapContext();
  const store = useAppStore();
  const [menuState, setMenuState] = useState(INITIAL_STATE);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setMenuState(INITIAL_STATE);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const closeMenu = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      closeMenu();
      setIsConfirmOpen(true);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const openConfirm = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsConfirmOpen(false);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const closeConfirm = t2;
  let t3;
  let t4;
  if ($[3] !== map || $[4] !== store) {
    t3 = () => {
      if (!map) {
        return;
      }
      const handleContextMenu = e => {
        const state = store.getState();
        if (!selectFogOfWarActive(state)) {
          return;
        }
        const markerLayers = PIN_INTERACTION_LAYER_IDS.filter(id => !!map.getLayer(id));
        if (markerLayers.length > 0) {
          let markerFeatures = [];
          try {
            markerFeatures = map.queryRenderedFeatures(e.point, {
              layers: markerLayers
            });
          } catch {}
          if (markerFeatures.length > 0) {
            return;
          }
        }
        if (selectLayerVisibility(state).regions) {
          const regions = selectMapData(state)?.regions?.features;
          if (regions?.length) {
            const lngLat = [e.lngLat.lng, e.lngLat.lat];
            for (const region of regions) {
              if (isPointInRegion(lngLat, region.geometry)) {
                return;
              }
            }
          }
        }
        e.originalEvent.preventDefault();
        e.originalEvent.stopPropagation();
        setMenuState({
          isOpen: true,
          x: e.originalEvent.clientX,
          y: e.originalEvent.clientY
        });
      };
      map.on("contextmenu", handleContextMenu);
      return () => {
        map.off("contextmenu", handleContextMenu);
      };
    };
    t4 = [map, store];
    $[3] = map;
    $[4] = store;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== isConfirmOpen || $[8] !== menuState) {
    t5 = {
      menuState,
      closeMenu,
      openConfirm,
      isConfirmOpen,
      closeConfirm
    };
    $[7] = isConfirmOpen;
    $[8] = menuState;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}